/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var WordIcon = createIcon("WordIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#185ABD';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.541 30c4.698 0 6.886-2.412 6.886-6.579 0-3.996-1.998-6.327-6.75-6.417-.298-.005-.67-.008-1.06-.01l-.593-.004-.576-.002-1.204-.002h-.068V30H9.54Zm.037-1.809h-1.18v-9.396h1.234c2.808 0 4.5 1.26 4.5 4.635 0 3.492-1.881 4.761-4.554 4.761Zm14.526 1.989c3.573 0 5.796-2.493 5.796-6.66 0-4.212-2.25-6.714-5.796-6.714-3.555 0-5.85 2.511-5.85 6.714 0 4.185 2.25 6.66 5.85 6.66Zm0-1.836c-2.116 0-3.447-1.431-3.447-4.797 0-3.411 1.331-4.905 3.447-4.905 2.114 0 3.41 1.485 3.41 4.905 0 3.366-1.277 4.797-3.41 4.797ZM37.36 30.18c3.41 0 4.833-2.133 5.13-4.5h-2.313c-.261 1.44-1.233 2.664-2.88 2.664-2.07 0-3.25-1.485-3.25-4.905 0-3.393 1.18-4.797 3.25-4.797 1.646 0 2.618 1.089 2.88 2.52h2.313c-.252-2.43-2.286-4.356-5.13-4.356-3.6 0-5.733 2.448-5.733 6.606 0 4.167 2.15 6.768 5.733 6.768Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.WordIcon",
  "replaceColor": true
});